import React, { useContext, useEffect } from 'react';

import { StepperContext } from 'app/design-system/components/Stepper/context';
import { useTranslation } from 'app/lang';

import { RegContext } from '../../../../context';
import endOfRegistrationImage from './images/enfOfRegistration.png';

import dictionary from './EndOfRegistration.dictionary.json';

import styles from './EndOfRegistration.module.scss';

const IMG_SIZES = {
  width: 104,
  height: 104,
};

export const EndOfRegistration = () => {
  const { t } =useTranslation();
  const { activeStep } = useContext(StepperContext);
  const { setRegData } = useContext(RegContext);

  useEffect(() => {
    setRegData((prevState) => ({ ...prevState, regStep: activeStep }));
  }, []);

  return (
    <div className={styles.root}>
      <img src={endOfRegistrationImage}
           width={IMG_SIZES.width}
           height={IMG_SIZES.height}
           alt={t(dictionary.alt)} />

      <h4 className={styles.title}>{t(dictionary.title)}</h4>

      <p className={styles.text}>{t(dictionary.text)}</p>
    </div>

  );
};

